import { isBrowser } from "../browser-utils";

const hasStoryblokParams = (): boolean => {
	if (!isBrowser()) return false;
	const urlParams = new URLSearchParams(window.location.search);
	return urlParams.has("_storyblok");
};

export const isInPreviewEditor = (): boolean => {
	return (
		process.env.GATSBY_STORYBLOK_STATUS === "draft" &&
		isBrowser() &&
		hasStoryblokParams()
	);
};
